import { Component, Inject, OnInit, ViewChild, HostListener } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { Globals } from '../models/globals.model';
import { GlobalService } from '../services/global.service';
import { HttpClient } from '@angular/common/http';
import { MatTableDataSource } from '@angular/material/table';
import { ModelParameter } from '../models/mlmodel/mlModel-parameters.model';
import { ConfigureNewModel } from '../models/configure-model/configure-new.model';
import { AlertComponent } from '../common/alert/alert.component';
import { MLService } from '../services/ml-service';
import { HttpService } from 'src/app/services/http.service';
import { apiurlValidator } from './apiurl.validator';
import { map, startWith } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

interface modelBasedData {
  value: Number;
  viewValue: string;
}

@Component({
  selector: 'app-configure-model',
  templateUrl: './configure-model.component.html',
  styleUrls: ['./configure-model.component.css']
})

export class ConfigureModelComponent implements OnInit {
  @ViewChild('inputParam') inputParam; // accessing the reference element
  @ViewChild('outputParam') outputParam; // accessing the reference element
  @HostListener('window:resize') onWindowResize() {
    if (window.innerWidth <= 768) {
      this.isVertical = true;
    } else { this.isVertical = false; }
  }
  response: any;
  dataToSend: any;
  selectedStep = 0;
  isVertical: boolean = false;
  activeParam: number = 0;
  invalidStepTwo = false;
  modelVersion = '';
  modelUrl = '';
  modelBased = 0;
  modelTypeList = ["Advanced Analytics", "Physics Based"];
  oauthAuthenticationList = [];
  secretList = [];
  isOauthClientAndSecret = false;
  isOauthManagedIdentity = false;
  modelBasedList: modelBasedData[] = [
    { value: 1, viewValue: 'Compiled (DLL, exe, etc.)' },
    { value: 2, viewValue: 'Surrogate' },
    { value: 3, viewValue: 'Simulation' },
  ];
  modelOptions: any[];
  baseModelTypesList = [];
  selectedBasedModel = 0;
  regProgress = false;
  isSecretAvailable = false;
  isScopeAvailable = false;
  isSubscriptionAvailable = false;
  isClientAvailable = false;
  IsFirstStepInvalid = false;
  isBasedType = false;
  isConfigureEdit = false;
  modelConfigrationId: any;
  modelVersionUsed = false;
  noInputOutputParam = "";
  subscriptionKey = "";
  clientIdName = "";
  scopeKey = "";
  secretName = "";
  paramExist: boolean = true;
  authExist: boolean = true;
  public isInputParameters: boolean = true;
  public modelData = new ConfigureNewModel();
  public displayedColumns: string[] = ["parameterName", "action"];
  public inputParameters: MatTableDataSource<ModelParameter>;
  public outputParameters: MatTableDataSource<ModelParameter>;
  filteredModelList: Observable<string[]>;
  public configureModelForm = new UntypedFormGroup({
    modelType: new UntypedFormControl(''),
    modelBased: new UntypedFormControl(''),
    modelUrl: new UntypedFormControl(''),
    modelVersion: new UntypedFormControl({ value: '', disabled: true }, Validators.required),
    modelName: new UntypedFormControl({ value: '', disabled: true }, Validators.required),
    authRequired: new UntypedFormControl(''),
    subscriptionKey: new UntypedFormControl({ value: '', disabled: true }, Validators.required),
    subscriptionValue: new UntypedFormControl({ value: '', disabled: true }, Validators.required),
    clientIdName: new UntypedFormControl({ value: '', disabled: true }, Validators.required),
    clientIdNameValue: new UntypedFormControl({ value: '', disabled: true }, Validators.required),
    secretName: new UntypedFormControl({ value: '', disabled: true }, Validators.required),
    secretNameValue: new UntypedFormControl({ value: '', disabled: true }, Validators.required),
    scopeKeyName: new UntypedFormControl({ value: '', disabled: true }, Validators.required),
    scopeKeyValue: new UntypedFormControl({ value: '', disabled: true }, Validators.required),
  });

  constructor(
    public httpService: HttpService,
    public dialogRef: MatDialogRef<ConfigureModelComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public fb: UntypedFormBuilder,
    public globals: Globals,
    public globalService: GlobalService,
    public httpClient: HttpClient,
    public mlService: MLService) { }

  ngOnInit(): void {
    this.configureModelForm = this.fb.group({
      modelType: ['', Validators.required],
      modelBased: ['', Validators.required],
      modelVersion: ['', [Validators.required, Validators.pattern('^[A-Za-z0-9][A-Za-z0-9_.-]*')]],
      modelUrl: ['', [Validators.required, Validators.pattern('https://([da-z.-]+).([a-z.]{2,6})([/w .-]*)??([^#\n\r]*)#?([^#\n\r]*)/?'), apiurlValidator.cannotContainSpace]],
      modelName: ['', [Validators.required, Validators.pattern('^[A-Za-z0-9][A-Za-z0-9_.-]*')]],
      authRequired: ['', Validators.required],
      subscriptionKey: ['', Validators.required],
      subscriptionValue: ['', Validators.required],
      clientIdName: ['', Validators.required],
      clientIdNameValue: ['', Validators.required],
      secretName: ['', Validators.required],
      secretNameValue: ['', Validators.required],
      scopeKeyName: ['', Validators.required],
      scopeKeyValue: ['', Validators.required]
    });
    this.validateFirstStep();
    this.setDefaultModel();
    this.getBaseModelTypes();
    this.getAuthDetailsList();
    this.getAllSecretsList();
    if (this.data.selectedData) { this.isConfigureEdit = Object.keys(this.data.selectedData).length > 0; }
    this.inputParameters = new MatTableDataSource([new ModelParameter()]);
    this.outputParameters = new MatTableDataSource([new ModelParameter()]);
    this.modelData.inputParameters = this.inputParameters.data;
    this.modelData.outputParameters = this.outputParameters.data;
    this.filteredModelList = this.configureModelForm.get('modelName').valueChanges.pipe(
      startWith(''),
      map(value => this._filterModel(value || '')),
    );
  }

  private _filterModel(value: string): string[] {
    const filterValue = value.toLowerCase();
    if (!filterValue || filterValue.length < 1) {
      this.modelOptions = [];
    }
    else {
      let modelsNameList = this.data.modelsData.map(a => a.registrationName);
      this.modelOptions = [...new Set(modelsNameList.filter(n => n))]; //'Filter' to remove null & 'Set' to remove duplicate model names
      return this.modelOptions.filter(option => option.toLowerCase().includes(filterValue));
    }
  }

  onModelVersionFocusOut(event: any) {
    let filteredModels = this.data.modelsData.filter((model) => {
      return model.registrationName === this.configureModelForm.get('modelName').value;
    });

    if (filteredModels && filteredModels.length > 0) {
      let modelVersionList = filteredModels.map(a => a.modelVersion); // get version list from model selected
      let modelVersionExist = modelVersionList.includes(event.target.value); //check if textbox value matches version from the version list
      this.modelVersionUsed = modelVersionExist ? true : false;
    }
  }

  getBaseModelTypes() {
    this.mlService.getBaseModelTypes().subscribe((data: any): void => {
      if (data.length > 0) {
        this.baseModelTypesList = data;
      }
      this.checkConfigureEdit(this.data);
    }, (error: Error) => {
      this.regProgress = false;
    });
  }

  getAllSecretsList() {
    this.mlService.getAllSecretsList().subscribe((data: any): void => {
      if (data.length > 0) {
        this.secretList = data;
      }
    }, (error: Error) => {
      this.regProgress = false;
    });
  }

  getAuthDetailsList() {
    this.mlService.getAuthDetailsList().subscribe((data: any): void => {
      if (data.length > 0) {
        this.oauthAuthenticationList = data;
      }
    }, (error: Error) => {
      this.regProgress = false;
    });
  }

  checkConfigureEdit(configureData) {
    this.regProgress = true;
    if (configureData.selectedData) {
      this.configureModelForm.get('modelType').setValue(configureData.selectedData.type);
      this.configureModelForm.get('modelBased').setValue(configureData.selectedData.baseModelId);
      this.onModelTypeSelected();
      this.configureModelForm.get('modelUrl').setValue(configureData.selectedData.url);
      this.configureModelForm.get('modelName').setValue(configureData.selectedData.registrationName);
      this.configureModelForm.get('modelVersion').setValue(configureData.selectedData.modelVersion);
      this.configureModelForm.get('authRequired').setValue(configureData.selectedData.authId);
      if (configureData.selectedData.authId === 1) {
        this.isOauthClientAndSecret = true;
        this.configureModelForm.get('subscriptionKey').setValue(configureData.selectedData.subscriptionKeyName);
        this.configureModelForm.get('subscriptionValue').setValue(configureData.selectedData.subscriptionKeyValue);
        this.configureModelForm.get('clientIdName').setValue(configureData.selectedData.clientKeyName);
        this.configureModelForm.get('clientIdNameValue').setValue(configureData.selectedData.clientKeyValue);
        this.configureModelForm.get('secretNameValue').setValue(configureData.selectedData.secretKeyValue);
        this.configureModelForm.get('secretName').setValue(configureData.selectedData.secretKeyName);
        this.configureModelForm.get('scopeKeyName').setValue(configureData.selectedData.scopeKeyName);
        this.configureModelForm.get('scopeKeyValue').setValue(configureData.selectedData.scopeKeyValue);
      } else if(configureData.selectedData.authId === 2) {
        this.isOauthManagedIdentity = true;
        this.configureModelForm.get('subscriptionKey').setValue(configureData.selectedData.subscriptionKeyName);
        this.configureModelForm.get('subscriptionValue').setValue(configureData.selectedData.subscriptionKeyValue);
        this.configureModelForm.get('scopeKeyName').setValue(configureData.selectedData.scopeKeyName);
        this.configureModelForm.get('scopeKeyValue').setValue(configureData.selectedData.scopeKeyValue);
      }

      let inputParamList = configureData.selectedData.inputParameters.map(v => ({
        parameterName: v.parameterName, parameterDefaultValue: v.parameterDefaultValue, parameterId: v.parameterId,
        captionName: "", parameterDataType: "", parameterUom: "", uomType: ""
      }
      ));

      let outputParamList = configureData.selectedData.outputParameters.map(v => ({
        parameterName: v.parameterName, parameterDefaultValue: v.parameterDefaultValue, parameterId: v.parameterId,
        captionName: "", parameterDataType: "", parameterUom: "", uomType: ""
      }
      ));
      
      if (inputParamList.length == 0) {
        let iParam = this.inputParameters.data;
        inputParamList = new MatTableDataSource(iParam);
        this.paramExist = true;
      }
      if (outputParamList.length === 0) {
        let iParam = this.outputParameters.data;
        outputParamList = iParam;
        this.paramExist = true;
      }

      this.modelData.inputParameters = inputParamList;
      this.modelData.outputParameters = outputParamList;
    }
    this.regProgress = false;
  }

  configureStepChange() {
    this.regProgress = true;
    this.invalidStepTwo = false;
    if (this.modelData.inputParameters.length !== 0 && this.modelData.outputParameters.length !== 0) {
      this.noInputOutputParam = "";
      this.inputParameters.data = this.modelData.inputParameters;
      this.outputParameters.data = this.modelData.outputParameters;
      this.regProgress = false;
    } else {
      this.regProgress = false;
      this.invalidStepTwo = true;
      if (this.data.selectedData) {
        this.noInputOutputParam = "Input and output parameters not available for "
          + "Model: " + this.data.selectedData.registrationName + " with "
          + "version: " + this.data.selectedData.modelVersion;
      }
    }
  }

  validateBeforeUpdate(event, modelData) {
    if (event.target.value && this.isConfigureEdit) {
      let latest = event.target.value;
      let secretNameExisting = this.data.selectedData.secretKeyName;
      let secretNameValueExisting = this.data.selectedData.secretKeyValue;
      let subscriptionKeyExisting = this.data.selectedData.subscriptionKeyName;
      let subscriptionValueExisting = this.data.selectedData.subscriptionKeyValue;
      let clientIdNameExisting = this.data.selectedData.clientKeyName;
      let clientIdNameValueExisting = this.data.selectedData.clientKeyValue;
      let scopeNameExisting = this.data.selectedData.scopeKeyName;
      let ScopeKeyValueExisting = this.data.selectedData.scopeKeyValue;

      if (secretNameExisting != latest
        || secretNameValueExisting != latest
        || subscriptionKeyExisting != latest
        || subscriptionValueExisting != latest
        || clientIdNameExisting != latest
        || clientIdNameValueExisting != latest
        || scopeNameExisting != latest
        || ScopeKeyValueExisting != latest
      ) {
        this.paramExist = false; // this will enable Save button if parameter is modified by user
      }
    }
  }

  validateParameter(event, rowIndex, modelData) {
    if (event.target.value && this.isConfigureEdit) {
      if (this.isInputParameters) {
        this.parameterValidate(rowIndex, this.data.selectedData.inputParameters, this.modelData.inputParameters);
      }
      else {
        this.parameterValidate(rowIndex, this.data.selectedData.outputParameters, this.modelData.outputParameters);
      }
    }
  }

  parameterValidate(rowIndex, selectedDataArray, modelDataArray) {    
    let inputNameExisiting;
    if (rowIndex < selectedDataArray.length) {
      inputNameExisiting = selectedDataArray[rowIndex].parameterName;
    }
    else {
      inputNameExisiting = '';
    }

    const isParamDuplicate = selectedDataArray.some(function (arrVal) {
      return modelDataArray[rowIndex].parameterName === arrVal.parameterName;
    });

    //check if new parameter value added and existing value not used
    this.paramExist = !(inputNameExisiting != undefined && inputNameExisiting !== modelDataArray[rowIndex].parameterName && !isParamDuplicate);

    let inputpara = this.inputParameters.data.filter(a => a.parameterName.length == 0);
    if (inputpara.length > 0) {
      this.paramExist = true;
    }
    let outputpara = this.outputParameters.data.filter(a => a.parameterName.length == 0);
    if (outputpara.length > 0) {
      this.paramExist = true;
    }
    this.validateOauth();
  }

  selectParamType(paramType, inputTabSelected) {
    if (inputTabSelected !== this.isInputParameters) {
      this.activeParam = 0;
    }
    if (paramType === 'input') {
      this.isInputParameters = true;
    } else {
      this.isInputParameters = false;
    }
  }

  selectionChange(selelctedStep) {
    this.selectedStep = selelctedStep;
  }

  setDefaultModel() {
    this.configureModelForm.get("modelType").patchValue(null);
    this.configureModelForm.get("authRequired").patchValue(null);
  }

  onModelTypeSelected() {
    let selectedModelType = this.configureModelForm.get('modelType').value;
    if (this.inputParam || this.outputParam) {
      this.inputParam.nativeElement.value = '';
      this.outputParam.nativeElement.value = '';
    }

    this.configureModelForm.get('modelType').setValue(selectedModelType);

    if (selectedModelType === 'Physics Based') {
      this.isBasedType = true;
      this.configureModelForm.get("modelBased").enable();
    } else {
      this.isBasedType = false;
      this.configureModelForm.get("modelBased").disable();
    }
  }

  keyUniqueCheck(key) {
    if (key === 'secretKey') {
      this.secretName = (this.configureModelForm.get('secretName').value).toLowerCase();
      this.isSecretAvailable = this.secretList.some(item => item.toLowerCase() === this.secretName);
      if (!this.isSecretAvailable && (this.secretName == this.subscriptionKey || this.secretName == this.scopeKey || this.secretName == this.clientIdName)) {
        this.isSecretAvailable = true;
      }
    }
    else if (key === 'scopeKeyName') {
      this.scopeKey = (this.configureModelForm.get('scopeKeyName').value).toLowerCase();
      this.isScopeAvailable = this.secretList.some(item => item.toLowerCase() === this.scopeKey);
      if (!this.isScopeAvailable && (this.scopeKey == this.subscriptionKey || this.scopeKey == this.secretName || this.scopeKey == this.clientIdName)) {
        this.isScopeAvailable = true;
      }
    }
  }

  secretNameCheck(key) {
    if (key === 'subscriptionKey') {
      this.subscriptionKey = (this.configureModelForm.get('subscriptionKey').value).toLowerCase();
      this.isSubscriptionAvailable = this.secretList.some(item => item.toLowerCase() === this.subscriptionKey);
      if (!this.isSubscriptionAvailable && (this.subscriptionKey == this.scopeKey || this.subscriptionKey == this.secretName || this.subscriptionKey == this.clientIdName)) {
        this.isSubscriptionAvailable = true;
      }
    }
    else if (key === 'clientKey') {
      this.clientIdName = (this.configureModelForm.get('clientIdName').value).toLowerCase();
      this.isClientAvailable = this.secretList.some(item => item.toLowerCase() === this.clientIdName);
      if (!this.isClientAvailable && (this.clientIdName == this.subscriptionKey || this.clientIdName == this.secretName || this.clientIdName == this.scopeKey)) {
        this.isClientAvailable = true;
      }
    }
  }

  validateOauth() {
    this.authExist = true;
    const selectedOauth = this.configureModelForm.get('authRequired').value;
    if (selectedOauth && this.isConfigureEdit) {      
      let authIdExisting = this.data.selectedData.authId;
      if (authIdExisting != selectedOauth) {
        this.authExist = false; // this will enable Save button if parameter is modified by user
      }
    }
  }

  onOauthSelected() {    
    let selectedOauth = this.configureModelForm.get('authRequired').value;
    this.configureModelForm.get('authRequired').setValue(selectedOauth);
    if (selectedOauth === 1) {
      this.isOauthClientAndSecret = true;
      this.isOauthManagedIdentity = false;
      this.configureModelForm.get("subscriptionKey").enable();
      this.configureModelForm.get("subscriptionValue").enable();
      this.configureModelForm.get("clientIdName").enable();
      this.configureModelForm.get("clientIdNameValue").enable();
      this.configureModelForm.get("secretName").enable();
      this.configureModelForm.get("secretNameValue").enable();
      this.configureModelForm.get("scopeKeyName").enable();
      this.configureModelForm.get("scopeKeyValue").enable();
    } else if (selectedOauth === 2) {
      this.isOauthManagedIdentity = true;
      this.isOauthClientAndSecret = false;

      this.configureModelForm.get("subscriptionKey").enable();
      this.configureModelForm.get("subscriptionValue").enable();     
      this.configureModelForm.get("scopeKeyName").enable();
      this.configureModelForm.get("scopeKeyValue").enable();

      this.configureModelForm.get("clientIdName").disable();
      this.configureModelForm.get("clientIdNameValue").disable();
      this.configureModelForm.get("secretName").disable();
      this.configureModelForm.get("secretNameValue").disable();
    } else {
      this.isOauthClientAndSecret = false;
      this.isOauthManagedIdentity = false;
      this.configureModelForm.get("subscriptionKey").disable();
      this.configureModelForm.get("subscriptionValue").disable();
      this.configureModelForm.get("clientIdName").disable();
      this.configureModelForm.get("clientIdNameValue").disable();
      this.configureModelForm.get("secretName").disable();
      this.configureModelForm.get("secretNameValue").disable();
      this.configureModelForm.get("scopeKeyName").disable();
      this.configureModelForm.get("scopeKeyValue").disable();
    }
    this.validateOauth();
  }

  onBasedModelSelected() {
    let selectedBasedModel = this.configureModelForm.get('modelBased').value;
    this.configureModelForm.get('modelBased').setValue(selectedBasedModel);
  }

  /**
   * Checks which panel should be displayed
   * @param index
   */
  displayAddParameters(index: number) {
    let check: boolean;
    if (this.isInputParameters) {
      check = (index == this.inputParameters.data.length - 1);
    } else {
      check = (index == this.outputParameters.data.length - 1);
    }
    return check;
  }

  /**Adds a new parameter to corresponding list */
  addNewParameter() {
    if (this.isInputParameters) {
      let iParam = this.inputParameters.data;
      iParam.push(new ModelParameter());
      this.inputParameters = new MatTableDataSource(iParam);
      this.paramExist = true;
    } else {
      let oParam = this.outputParameters.data;
      oParam.push(new ModelParameter());
      this.outputParameters = new MatTableDataSource(oParam);
      this.paramExist = true;
    }
  }

  /**
   * Deletes model at selected index
   * @param index
   */
  deleteModel(index: number) {
    if (this.isInputParameters) {
      if (this.inputParameters.data.length == 1) {
        let iParam = this.inputParameters.data;
        iParam.push(new ModelParameter());
        this.inputParameters = new MatTableDataSource(iParam);
        this.paramExist = true;
      }
      let iParam = this.inputParameters.data;
      iParam.splice(index, 1);
      this.inputParameters = new MatTableDataSource(iParam);
      let inputpara = this.inputParameters.data.filter(a => a.parameterName.length == 0);
      if (inputpara.length > 0) {
        this.paramExist = true;
      }
      else {
        this.paramExist = false;
      }

    } else {
      if (this.outputParameters.data.length == 1) {
        let iParam = this.outputParameters.data;
        iParam.push(new ModelParameter());
        this.outputParameters = new MatTableDataSource(iParam);
        this.paramExist = true;
      }

      let oParam = this.outputParameters.data;
      oParam.splice(index, 1);
      this.outputParameters = new MatTableDataSource(oParam);
      let outputpara = this.outputParameters.data.filter(a => a.parameterName.length == 0);
      if (outputpara.length > 0) {
        this.paramExist = true;
      }
      else {
        this.paramExist = false;
      }
    }
  }

  /**Check for enabling/disabling Save button */
  disableSave() {
    let selectedModelType = this.configureModelForm.get('modelType').value;
    if (selectedModelType === 'Physics Based') {
      this.selectedBasedModel = this.configureModelForm.get('modelBased').value;
    } else {
      this.selectedBasedModel = 0;
    }
    let check: boolean;
    check = !this.configureModelForm.valid;
    if (!check) {
      let inputs = this.inputParameters?.data.map(d => d.parameterName);
      let outputs = this.outputParameters?.data.map(d => d.parameterName);

      let iParam: boolean = !this.globalService.isNotNullObject(this.inputParameters)
        || (this.globalService.isNotNullObject(this.inputParameters) && inputs.includes(""));

      let oParam: boolean = !this.globalService.isNotNullObject(this.outputParameters)
        || (this.globalService.isNotNullObject(this.outputParameters) && outputs.includes(""));
      check = iParam || oParam;
    }
    return check;
  }

  onSubmit() {
    this.regProgress = true;
    let inputParamData = this.inputParameters.data.filter(a => a.parameterName != '' && a.parameterName != null);
    let inputParamList = inputParamData.map(v => ({
      ParameterName: v.parameterName,
      ParameterDefaultValue: "",
      ParameterType: "1",
      ModelName: this.configureModelForm.value.modelName
    }
    ));

    let outputParamData = this.outputParameters.data.filter(a => a.parameterName != '' && a.parameterName != null);
    let outputParamList = outputParamData.map(v => ({
      ParameterName: v.parameterName,
      ParameterDefaultValue: "",
      ParameterType: "2",
      ModelName: this.configureModelForm.value.modelName
    }
    ));

    this.modelData = this.configureModelForm.value;
    this.modelData.inputParameters = inputParamData;
    this.modelData.outputParameters = outputParamData;
    this.modelConfigrationId = (this.isConfigureEdit) ? this.data.selectedData.modelConfigrationId : 0;

    this.dataToSend =
    {
      "type": this.configureModelForm.value.modelType,
      "baseModelId": this.configureModelForm.value.modelBased,
      "url": this.configureModelForm.value.modelUrl,
      "registrationName": this.configureModelForm.value.modelName,
      "modelVersion": this.configureModelForm.value.modelVersion,
      "isActive": "1",
      "createdBy": this.globalService.loggedInUser,
      "lastModifiedBy": this.globalService.loggedInUser,
      "inputParameters": inputParamList,
      "outputParameters": outputParamList,
      "modelConfigrationId": this.modelConfigrationId,
      "AuthId": this.configureModelForm.value.authRequired,
      "SubscriptionKeyName": this.configureModelForm.value.subscriptionKey,
      "subscriptionKeyValue": this.configureModelForm.value.subscriptionValue,
      "ClientKeyName": this.configureModelForm.value.clientIdName,
      "ClientKeyValue": this.configureModelForm.value.clientIdNameValue,
      "SecretKeyName": this.configureModelForm.value.secretName,
      "SecretKeyValue": this.configureModelForm.value.secretNameValue,
      "ScopeKeyName": this.configureModelForm.value.scopeKeyName,
      "ScopeKeyValue": this.configureModelForm.value.scopeKeyValue,
    }
    this.regProgress = false;

    if (typeof this.dataToSend.type !== 'undefined') {
      this.mlService.saveData(this.dataToSend).subscribe((response: any): void => {
        this.regProgress = false;
        this.globalService.showAlert(AlertComponent, { success: true, message: "Model configuration data saved successfully!" });
        this.invokeSaveApi(response);
        this.dialogRef.close('added');
      },
        error => {
          this.globalService.showAlert(AlertComponent, { success: false, message: "Error while saving data!" });
          this.regProgress = false;
        });
    }
  }

  invokeSaveApi(modelConfigrationId) {
    //Generate form data for save post call
    const formData: FormData = new FormData();
    formData.set('data', JSON.stringify(this.modelData));
    formData.append('modelConfigrationId', modelConfigrationId);
    this.mlService.saveConfigureModel(formData).subscribe((data: any) => {
      this.regProgress = false;
    });
    this.configureModelForm.reset();
    this.deleteNewParameter();

    // clearing the value
    if (this.inputParam) {
      this.inputParam.nativeElement.value = '';
      this.outputParam.nativeElement.value = '';
    }
  }

  deleteNewParameter() {
    if (!this.isInputParameters) {
      let iParam = this.inputParameters.data;
      iParam.splice(1, iParam.length);
      this.inputParameters = new MatTableDataSource(iParam);

      let oParam = this.outputParameters.data;
      oParam.splice(1, oParam.length);
      this.outputParameters = new MatTableDataSource(oParam);
    }
  }

  validateFirstStep() {
    this.IsFirstStepInvalid = true;
    let modelname = this.configureModelForm.get('modelName').value;
    let modelType = this.configureModelForm.get('modelType').value;
    let modelBased = this.configureModelForm.get('modelBased').value;
    let modelVersion = this.configureModelForm.get('modelVersion').value;
    let modelUrl = this.configureModelForm.get('modelUrl').value;
    let authId = this.configureModelForm.get('authRequired').value;
    let subscriptionKey = this.configureModelForm.get('subscriptionKey').value;
    let subscriptionValue = this.configureModelForm.get('subscriptionValue').value;
    let clientIdName = this.configureModelForm.get('clientIdName').value;
    let clientIdNameValue = this.configureModelForm.get('clientIdNameValue').value;
    let secretName = this.configureModelForm.get('secretName').value;
    let secretNameValue = this.configureModelForm.get('secretNameValue').value;
    let scopeKeyName = this.configureModelForm.get('scopeKeyName').value;
    let scopeKeyValue = this.configureModelForm.get('scopeKeyValue').value;
    if (modelname == '' || modelType == null || modelVersion == '' || modelUrl == '' || authId == null) {
      this.IsFirstStepInvalid = true;
    }
    else {
      this.IsFirstStepInvalid = false;
      if (modelType == 'Physics Based' && modelBased == '') {
        this.IsFirstStepInvalid = true;
      }
      if ((authId == 1 && (subscriptionKey == '' || subscriptionValue == '' || clientIdName == '' || clientIdNameValue == '' || secretName == '' ||
        secretNameValue == '' || scopeKeyName == '' || scopeKeyValue == '')) || 
        (authId == 2 && (subscriptionKey == '' || subscriptionValue == '' || scopeKeyName == '' || scopeKeyValue == ''))) {
          this.IsFirstStepInvalid = true;        
      }
    }    
    this.validateOauthFields(authId);
    return (this.IsFirstStepInvalid);
  }

  validateOauthFields(authId:any) {
    if ((authId == 1 && (this.isClientAvailable || this.isSubscriptionAvailable || this.isSecretAvailable || this.isScopeAvailable)) ||
        (authId == 2 && (this.isSubscriptionAvailable || this.isScopeAvailable))) {
      this.IsFirstStepInvalid = true;
    }
  }
}
